import React, {useState, useEffect} from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import DragDrop from '../components/dragDrop.js';
import SelectedImageDisplay from '../components/selectedImageDisplay.js';
import PatternSelector from '../components/patternSelector.js';
import Editor from '../components/editor.js'
import {useParams} from 'react-router-dom';
import db from '../database'; // Import the PouchDB instance from your db.js file

const styles = {
    dragBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width:'100%'
    },
    imagesDisplay: {
        position: 'absolute',
        right: 0,
        maxHeight: '100%',
        overflow: 'scroll'
    },
    patternSelector: {
        display: 'flex',
    },
    editor: {
        width: '80%'
    },
    headerCard: {
        marginBottom:4
    }

}
const MovieHeader = ({name, language}) => {
    return (
        <Card sx={styles.headerCard}>
          <CardContent>
            <Typography variant="h5" component="div">
              {name} ({language})
            </Typography>
          </CardContent>
        </Card>
      );
}

function Home() {
    const [selectedImages, setSelectedImages] = useState([])
    const [selectedPattern, setSelectedPattern] = useState()
    const [movie, setMovie] = useState()
    const {id} = useParams();

    useEffect(()=>{
        db.get(id).then((result) => {
            setMovie(result)
        }).catch((error) => {
            setMovie(null)
            console.error('Error querying documents:', error);
        });
    }, [id])

  return (
    <Box>
        <MovieHeader name={movie?.title} language={movie?.language}/> 
      <Box sx={styles.dragBox}>
      {selectedImages.length === 0 && (<DragDrop images={selectedImages} setSelectedImages={setSelectedImages}/>)}
      </Box>
      <Box sx={styles.imagesDisplay}>
          <SelectedImageDisplay selectedImages={selectedImages}/>
      </Box>
      {selectedImages.length > 0 && !selectedPattern && (<Box sx={styles.patternSelector}>
          <PatternSelector selectedPattern={selectedPattern} setSelectedPattern={setSelectedPattern}/>
      </Box>)}
      {selectedImages.length > 0 && selectedPattern && (<Box sx={styles.editor}>
          <Editor movie={movie} selectedPattern={selectedPattern} selectedImages={selectedImages}/>
      </Box>)}

    </Box>
  );
}

export default Home;

